import styled from 'styled-components';
import IconButton from 'APP_COMPONENTS/common/buttons/icon-button.js';

const StyledIconButton = styled(IconButton)`
  margin-top: -5px;
  margin-left: 12px;

  &:focus {
    background-color: #273b55;
  }

  &:disabled[data-preview-mode='true'] {
    background-color: transparent;
    filter: opacity(50%);
  }
`;

export default StyledIconButton;
